import './SubHeader.scss';

function SubHeader(props: { children: any }) {
    const { children } = props;
    return <div className="mafia-sub-header">{children}</div>
}

export default SubHeader;